import {
  Box,
  Group,
  ThemeIcon,
  Tooltip,
  UnstyledButton,
  rem,
} from "@mantine/core";
import classes from "./NavbarLinksGroup.module.css";
import { Link, useMatches } from "react-router-dom";
import { forwardRef } from "react";
import { useUIStore } from "../../../stores/UIStore";
import { IconChevronRight } from "@tabler/icons-react";

const NavbarLinkButton = forwardRef(
  (
    {
      icon: Icon,
      path,
      secondPath,
      closed,
      name,
      noNav,
      hasLinks,
      opened,
      customIcon,
      isPricing,
      onClick,
      innerStyle,
      ...others
    },
    ref
  ) => {
    const matches = useMatches();

    const active =
      matches.find((x) => x.pathname.includes(path)) ||
      (secondPath
        ? matches.find((x) => x.pathname.includes(secondPath))
        : false);

    return (
      <Tooltip label={name} disabled={!closed} position="right" offset={-4}>
        <UnstyledButton
          {...others}
          component={noNav ? undefined : Link}
          to={path}
          className={`fill-secondary-on-hover-source ${classes.control} ${
            customIcon ? "" : "bump"
          } ${active ? "active" : ""}`}
          ref={ref}
          py="xs"
          px={19}
          pl={closed ? 18 : 16}
          style={{
            color: active
              ? "var(--mantine-primary-color-filled)"
              : "var(--mantine-color-dark-3)",
            // borderLeft: "6px solid",
            // borderLeftColor: matches.find((x) => x.pathname.includes(path))
            //   ? "var(--mantine-primary-color-filled)"
            //   : "transparent",
            background: active
              ? "var(--mantine-color-primary-0)"
              : "transparent",
          }}
          fz={13}
          onClick={
            onClick
              ? onClick
              : () => {
                  let locked = useUIStore.getState().pinnedNavbar;
                  if (!locked) {
                    useUIStore.getState().setNavbarClosed(true);
                    useUIStore.getState().setCampaignOpened(false);
                  }
                }
          }
        >
          <Group
            justify="space-between"
            gap={0}
            wrap="nowrap"
            style={{ borderRadius: 8, ...innerStyle }}
          >
            <Box style={{ display: "flex", alignItems: "center" }}>
              {customIcon || (
                <ThemeIcon
                  variant={"subtle"}
                  size={32}
                  color={active ? "primary" : "gray.2"}
                >
                  <Icon
                    style={{
                      width: rem(20),
                      height: rem(20),
                      marginLeft: 4,
                      color: active ? "#fcfbff" : "var(--mantine-color-gray-6)",
                    }}
                  />
                </ThemeIcon>
              )}
              {!closed && (
                <Box
                  ml="md"
                  fw={isPricing ? 650 : active ? 650 : 550}
                  className="name"
                >
                  {name}
                </Box>
              )}
            </Box>

            {hasLinks && !closed && (
              <IconChevronRight
                className={classes.chevron}
                style={{
                  marginRight: -8,
                  width: rem(16),
                  height: rem(16),
                  fill: "none !important",
                  transform: opened ? "rotate(-90deg)" : "none",
                }}
              />
            )}
          </Group>
        </UnstyledButton>
      </Tooltip>
    );
  }
);

NavbarLinkButton.displayName = "NavbarLinkButton";

export default NavbarLinkButton;
